// Do NOT add "use client" to this file
import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/retailer-visitor-shared/views/search-v2/util/DEPRECATED_backwardsCompatibleValues";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import {
  isNotUndefined,
  isTupleOfLength,
} from "@faire/web--source/common/typescriptUtils";
import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import { ProductVariationType } from "@faire/web-api--source/indigofair/data/ProductVariationType";

export const getAltTag = (
  params: {
    productName: string | undefined;
    pageType?: PAGE_TYPE;
    title?: string;
    brandName?: string;
  },
  strictLocalize: StrictLocalizeFunction
) => {
  const { productName, pageType, title, brandName } = params;

  switch (pageType) {
    case PAGE_TYPE.CATEGORY:
      return strictLocalize(
        {
          defaultMessage: "{productName} in {title}",
          description: {
            text: "alt tag for product images on the cateogry page; alt tags are used for web crawling and screen readers",
          },
        },
        DEPRECATED_backwardsCompatibleValues({
          productName: productName,
          title: title,
        })
      );

    case PAGE_TYPE.DISCOVER:
      return strictLocalize(
        {
          defaultMessage: "{productName} and other {title} trending on Faire.",
          description: {
            text: "alt tag for product images on the discover page; alt tags are used for web crawling and screen readers",
          },
        },
        DEPRECATED_backwardsCompatibleValues({
          productName: productName,
          title: title,
        })
      );
    case PAGE_TYPE.CART:
    case PAGE_TYPE.BRAND:
      return strictLocalize(
        {
          defaultMessage: "{productName} for wholesale by {brandName}",
          description: {
            text: "alt tag for product images on the brand page; alt tags are used for web crawling and screen readers",
          },
        },
        DEPRECATED_backwardsCompatibleValues({
          productName: productName,
          brandName: brandName,
        })
      );
    default:
      return undefined;
  }
};

export const getAltTagProductPage = (
  product: IProductPageResponse.IPdpProduct,
  isEnglish: boolean,
  brandName: string | undefined,
  strictLocalize: StrictLocalizeFunction
) => {
  const colorEntryValues =
    product.purchase_information?.variation_map?.entries?.find(
      (entry) => entry.type === ProductVariationType.COLOR
    )?.entry_values;
  if (
    isNotUndefined(colorEntryValues) &&
    isTupleOfLength(colorEntryValues, 1)
  ) {
    let fixedColor = colorEntryValues[0].value;
    const productName = product.name?.translated ?? product.name?.original;
    let altTag = `${fixedColor} ${productName}`;
    /**
     * If page is in English, we will
     * remove all special characters and numbers from fixedColor
     * check if fixedColor is partially in product name
     * if yes, alt tag would just be product name
     * if no, alt tag would be fixedColor + product name
     *
     * When page is not in English,
     * alt tag is fixedColor + product name
     */
    if (isEnglish && fixedColor && productName) {
      fixedColor = fixedColor.replace(/[^a-zA-Z ]/g, " ");
      const fixedColorSplited = fixedColor.split(/\s+/);
      altTag = `${fixedColorSplited.join(" ")} ${productName}`;
      const productNameSplited = productName?.toLowerCase().split(/\s+/);
      if (
        fixedColorSplited.some((word) =>
          productNameSplited.includes(word.toLowerCase())
        )
      ) {
        altTag = productName;
      }
    }

    return strictLocalize(
      {
        defaultMessage: "{product} for wholesale on Faire",
        description: {
          text: "alt tag for product images on the product page; alt tags are used for web crawling and screen readers",
        },
      },
      DEPRECATED_backwardsCompatibleValues({
        product: altTag,
      })
    );
  }
  return strictLocalize(
    {
      defaultMessage: "{brandName} - Wholesale {taxonomyType} - {productName}",
      description: {
        text: "alt tag for product images on the product page; alt tags are used for web crawling and screen readers",
      },
    },
    DEPRECATED_backwardsCompatibleValues({
      productName: product.name?.translated ?? product.name?.original,
      brandName: brandName,
      taxonomyType: product.details?.taxonomy_type?.name,
    })
  );
};
